import TaskExecutionHistoryTable from "../../../_metronic/partials/widgets/tables/TaskExecutionHistoryTable";

function PlatformTaskHistory() {
  return (
    <div>
      <TaskExecutionHistoryTable />
    </div>
  );
}

export default PlatformTaskHistory;
